<template>
  <v-dialog ref="dialog" v-model="modal" width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :value="formatDisplayedDate(date)" label="Fecha" append-icon="event" readonly v-bind="attrs"
        v-on="on"></v-text-field>
    </template>
    <v-date-picker v-model="date" :type="isMonthly ? 'month' : 'date'" scrollable locale="es-GT"
      :max="isMonthly ? formatDate(new Date(), false, '-', true) : formatDate(new Date(), true, '-', true)"
      :first-day-of-week="1">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">Salir</v-btn>
      <v-btn text color="primary" @click="onSelectDate">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import { formatDate } from '../../services/timeUtils'
export default {
  props: {
    isMonthly: Boolean,
    value: [Number, String]
  },
  data() {
    return {
      date: this.isMonthly ? formatDate(this.value ? new Date(this.value) : new Date(), false, '-', true) : formatDate(this.value ? new Date(this.value) : new Date(), true, '-', true),
      menu: false,
      modal: false,
    }
  },
  created() {
    this.formatDate = formatDate
  },
  methods: {
    onSelectDate(ev) {
      this.modal = false
      const dateArr = this.date.split('-')
      const date = new Date()
      date.setUTCFullYear(+dateArr[0])
      date.setUTCMonth(parseInt(dateArr[1]) - 1)
      if (dateArr[2]) date.setUTCDate(parseInt(dateArr[2]))
      date.setUTCHours(0, 0, 0, 0)

      this.$emit('onSelectDate', date)
    },
    formatDisplayedDate(dateStr) {
      if (!dateStr) return ''
      const dates = dateStr.split('-')
      return `${dates[2] ? dates[2] + '-' : ''}${dates[1]}-${dates[0]}`
    },
  },
  watch: {
    value() {
      const date = this.value ? new Date(this.value) : new Date()
      this.date = this.isMonthly ? formatDate(date, false, '-', true) : formatDate(date, true, '-', true)
    }
  }
}
</script>

<style></style>